import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class GroupService extends RestfulService<Models.Group> {

  constructor(public restService: RestService) {
    super(Models.Group);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('groups');
  }

}
